import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';

@Component({
  selector: 'app-reg-driver-verification',
  templateUrl: './reg-driver-verification.component.html',
  styleUrls: ['./reg-driver-verification.component.scss']
})
export class RegDriverVerificationComponent implements OnInit {
  globals = Globals;
  model: any = {};
  driverProfile: any = {};
  expiryDate: any = null;
  isLoadingResults = false;
  httpSub$: Subscription = null;
  fileToUpload: File = null;

  constructor(private service: HttpService, private router: Router) {}

  ngOnInit() {
    this.driverProfile = JSON.parse(localStorage.getItem('driverProfile') || '{}');
    if (this.driverProfile) {
      this.model.licenseImage = this.driverProfile.licenseFrontImage;
      this.model.idImageUrl = this.driverProfile.identityCardFrontImage;
      if (this.driverProfile.licenseExpiry) {
        this.expiryDate = new Date(this.driverProfile.licenseExpiry * 1000);
      }
    }
  }

  uploadPackageImage(files: FileList, type: number) {
    if (!files || !files[0]) {
      return;
    }
    if (files[0].type === 'image/gif') {
      this.service.showError('Gif images are not allowed', 'Verification');
      return;
    }
    this.fileToUpload = files.item(0);
    this.isLoadingResults = true;
    this.httpSub$ = this.service.uploadImage(this.globals.urls.signUp.noauth.uploadImage, this.fileToUpload).subscribe(
      res => {
        this.isLoadingResults = false;
        if (type === 1) {
          this.model.licenseImage = res.data.url;
        } else {
          this.model.idImageUrl = res.data.url;
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  clearImage(type: number) {
    if (type === 1) {
      this.model.licenseImage = null;
    } else {
      this.model.idImageUrl = null;
    }
  }

  next() {
    if (!this.model.licenseImage || !this.model.idImageUrl) {
      this.service.showError('Please upload both license images', 'Error');
      return;
    }
    this.driverProfile.licenseFrontImage = this.model.licenseImage;
    this.driverProfile.identityCardFrontImage = this.model.idImageUrl;
    this.driverProfile.licenseExpiry = this.expiryDate
      ? moment(this.expiryDate).valueOf() / 1000
      : null;
    localStorage.setItem('driverProfile', JSON.stringify(this.driverProfile));
    this.router.navigate(['/registration/drivers/payout-setup']);
  }

  back() {
    this.router.navigate(['/registration/drivers/assign-vehicle']);
  }
}
